import { Toaster } from 'react-hot-toast';

/**
 * The handoff's toast: brown-deep, bottom-centre, ~3.2s (set in
 * services/notify.ts), check icon on success, message ends with a period.
 * Every write fires one; dialogs close on success.
 */
export function AppToaster() {
  return (
    <Toaster
      position="bottom-center"
      containerStyle={{ bottom: 24, zIndex: 1000 }}
      toastOptions={{
        style: {
          background: 'var(--hp-brown-deep)',
          color: 'var(--hp-cream)',
          fontFamily: 'var(--font-body)',
          fontSize: 14,
          borderRadius: 'var(--r-app-card)',
          padding: '10px 16px',
          boxShadow: 'var(--shadow-lg)',
        },
        success: { iconTheme: { primary: 'var(--hp-green)', secondary: 'var(--hp-brown-deep)' } },
        error: { iconTheme: { primary: 'var(--hp-danger)', secondary: 'var(--hp-cream)' } },
      }}
    />
  );
}
